
import React from 'react';
import { User, ListTodo, Search } from 'lucide-react';
import { Button } from "@/components/ui/button";

interface OnboardingGuidelinesProps {
  onAddStage: () => void;
}

const OnboardingGuidelines: React.FC<OnboardingGuidelinesProps> = ({ onAddStage }) => {
  return (
    <div className="w-full flex flex-col items-center justify-center py-12 px-4 text-center bg-gray-50 dark:bg-gray-900/50 rounded-lg border-2 border-dashed border-gray-200 dark:border-gray-700">
      <h2 className="text-2xl font-medium mb-6 font-handwritten text-primary">Create Your User Journey Map</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mb-8">
        <div className="flex flex-col items-center p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-md">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-500 dark:text-blue-300 mb-4">
            <User className="h-6 w-6" />
          </div>
          <h3 className="font-medium mb-2 font-handwritten text-primary">1. Define User Profile</h3>
          <p className="text-sm text-muted-foreground">
            Add user information, their scenario, and goal they're trying to accomplish.
          </p>
        </div>
        
        <div className="flex flex-col items-center p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-md">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-500 dark:text-blue-300 mb-4">
            <ListTodo className="h-6 w-6" />
          </div>
          <h3 className="font-medium mb-2 font-handwritten text-primary">2. Map Journey Stages</h3>
          <p className="text-sm text-muted-foreground">
            Create stages to represent the user's experience, emotions, pain points, and opportunities.
          </p>
        </div>
        
        <div className="flex flex-col items-center p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-md">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-500 dark:text-blue-300 mb-4">
            <Search className="h-6 w-6" />
          </div>
          <h3 className="font-medium mb-2 font-handwritten text-primary">3. Distill Insights</h3>
          <p className="text-sm text-muted-foreground">
            Document key gaps and opportunities to improve the user experience.
          </p>
        </div>
      </div>
      
      <Button onClick={onAddStage} size="lg" className="px-6 font-handwritten text-lg">
        Add First Stage
      </Button>
    </div>
  );
};

export default OnboardingGuidelines;
